export default {
  name: [
    { required: true, message: '请输入股票代码', trigger: 'change' },
    { max: 6, message: '超出最大长度 (6)', trigger: 'change' },
    { min: 6, message: '小于长度 (6)', trigger: 'change' },
  ],
  remark: [{ max: 256, message: '超出最大长度 (256)', trigger: 'change' }],
}